import { windowColors } from "../../entities/constants";

export default function Side(
  p5,
  trait,
  xcenter,
  margin,
  size,
  depth,
  a,
  textSize
) {
  this.x1 = size * p5.cos(a) + xcenter;
  this.y1 = size * p5.sin(a) + margin;
  this.x2 = size * p5.cos(a + 360 / trait.size) + xcenter;
  this.y2 = size * p5.sin(a + 360 / trait.size) + margin;
  this.x3 = size * p5.cos(a) + xcenter;
  this.y3 = size * p5.sin(a) + margin;
  this.x4 = (size - depth) * p5.cos(a) + xcenter;
  this.y4 = (size - depth) * p5.sin(a) + margin;
  this.x5 = (size - depth) * p5.cos(a + 360 / trait.size) + xcenter;
  this.y5 = (size - depth) * p5.sin(a + 360 / trait.size) + margin;

  // DOOR

  this.xdoor2 =
    (size + depth / (trait.size / 50)) * p5.cos(a + 270 / trait.size) + xcenter;
  this.ydoor2 =
    (size + depth / (trait.size / 50)) * p5.sin(a + 270 / trait.size) + margin;

  // WINDOW

  this.xwindow1 = (size - depth / 2) * p5.cos(a) + xcenter;
  this.ywindow1 = (size - depth / 2) * p5.sin(a) + margin;
  this.xwindow2 = (size - depth / 2) * p5.cos(a + 360 / trait.size) + xcenter;
  this.ywindow2 = (size - depth / 2) * p5.sin(a + 360 / trait.size) + margin;

  this.color = "rgba(0, 0, 0, 0)";
  this.textColor = "blue";

  this.d = p5.dist(this.x1, this.y1, this.x2, this.y2);

  this.turn = (x) => {
    this.x1 = size * p5.cos(x) + xcenter;
    this.y1 = size * p5.sin(x) + margin;
    this.x2 = size * p5.cos(x + 360 / trait.size) + xcenter;
    this.y2 = size * p5.sin(x + 360 / trait.size) + margin;
    this.x3 = size * p5.cos(x) + xcenter;
    this.y3 = size * p5.sin(x) + margin;
    this.x4 = (size - depth) * p5.cos(x) + xcenter;
    this.y4 = (size - depth) * p5.sin(x) + margin;
    this.x5 = (size - depth) * p5.cos(x + 360 / trait.size) + xcenter;
    this.y5 = (size - depth) * p5.sin(x + 360 / trait.size) + margin;
  };

  this.render = (p5, i, wallTrait) => {
    let lineDepth = -5;
    let numberDepth = 2;
    if (textSize > 8) {
      if (i % 2 === 0) {
        lineDepth = 7;
      }
    }

    // NUMBER

    this.xnumber =
      (size - depth * numberDepth) * p5.cos(a + 180 / trait.size) + xcenter;
    this.ynumber =
      (size - depth * numberDepth) * p5.sin(a + 180 / trait.size) + margin;

    const xpoint1 = (size - depth * lineDepth) * p5.cos(a) + xcenter;
    const ypoint1 = (size - depth * lineDepth) * p5.sin(a) + margin;
    const xpoint2 =
      (size - depth * lineDepth) * p5.cos(a + 360 / trait.size) + xcenter;
    const ypoint2 =
      (size - depth * lineDepth) * p5.sin(a + 360 / trait.size) + margin;

    const xpoint3 = size * p5.cos(a) + xcenter;
    const ypoint3 = size * p5.sin(a) + margin;
    const xpoint4 = size * p5.cos(a + 360 / trait.size) + xcenter;
    const ypoint4 = size * p5.sin(a + 360 / trait.size) + margin;

    this.xline1 = xpoint1 - (xpoint1 - xpoint2) / 2;
    this.yline1 = ypoint1 - (ypoint1 - ypoint2) / 2;
    this.xline2 = xpoint3 - (xpoint3 - xpoint4) / 2;
    this.yline2 = ypoint3 - (ypoint3 - ypoint4) / 2;

    if (wallTrait[i].frenchDoor) {
      this.color = "lightgrey";
    }

    if (wallTrait[i].doors) {
      p5.push();
      p5.stroke(0);
      p5.strokeWeight(1);
      p5.fill(this.color);
      p5.translate(this.x1, this.y1);
      p5.rotate(a - 30);
      p5.rect(0, 0, -depth / 2, this.d);
      p5.pop();

      p5.push();
      p5.strokeWeight(1);
      p5.line(this.x3, this.y3, this.x4, this.y4);
      p5.pop();
    } else {
      p5.push();
      p5.stroke(0);
      p5.strokeWeight(1);
      p5.fill(this.color);
      p5.beginShape();
      p5.vertex(this.x2, this.y2);
      p5.vertex(this.x1, this.y1);
      p5.vertex(this.x3, this.y3);
      p5.vertex(this.x4, this.y4);
      p5.vertex(this.x5, this.y5);
      p5.endShape();
      p5.pop();
    }

    if (wallTrait[i].windows) {
      p5.push();
      p5.stroke(0);
      p5.strokeWeight(1);
      p5.line(this.xwindow1, this.ywindow1, this.xwindow2, this.ywindow2);
      p5.pop();

      p5.push();
      p5.strokeWeight(0.5);

      p5.pop();

      const width1 = wallTrait[i].window1.windowW / wallTrait[i].pixels;
      const height1 = wallTrait[i].window1.windowH / wallTrait[i].pixels;
      const sill1 = wallTrait[i].window1.sill / wallTrait[i].pixels;
      let windowText1 = `${width1}x${height1}\n${wallTrait[i].window1.windowType}\n${sill1}" sill`;

      const width2 = wallTrait[i].window2.windowW / wallTrait[i].pixels;
      const height2 = wallTrait[i].window2.windowH / wallTrait[i].pixels;
      const sill2 = wallTrait[i].window2.sill / wallTrait[i].pixels;
      let windowText2 = `\n_____\n${width2}x${height2}\n${wallTrait[i].window2.windowType}\n${sill2}" sill`;

      p5.push();
      p5.fill(255);
      p5.rectMode(p5.CENTER);
      p5.strokeWeight(0.2);
      p5.textAlign(p5.CENTER, p5.CENTER);
      p5.textSize(textSize);
      p5.textStyle(p5.BOLD);
      if (wallTrait[i].windows > 1) {
        p5.line(this.xnumber, this.ynumber, this.xline1, this.yline1);
        if (wallTrait[i].window1.tempered === "TEMPERED") {
          windowText1 = windowText1 + `\nTEMPERED`;
        }
        if (wallTrait[i].window2.tempered === "TEMPERED") {
          windowText2 = windowText2 + `\nTEMPERED`;
        }

        windowText1 = windowText1 + windowText2;
        p5.noStroke();

        p5.fill(windowColors[wallTrait[i].window1.installment]);
        p5.ellipse(this.xline1 - 30, this.yline1 + 20, 20);
        p5.fill(windowColors[wallTrait[i].window2.installment]);
        p5.ellipse(this.xline1 - 30, this.yline1 - 20, 20);
        p5.fill(0);
        p5.text(windowText1, this.xline1, this.yline1);
      } else {
        p5.line(this.xnumber, this.ynumber, this.xline1, this.yline1);
        if (wallTrait[i].window1.tempered === "TEMPERED") {
          windowText1 = windowText1 + `\nTEMPERED`;
        }
        p5.noStroke();
        p5.fill(windowColors[wallTrait[i].window1.installment]);
        p5.ellipse(this.xline1 - 30, this.yline1, 20);
        p5.fill(0);
        p5.text(windowText1, this.xline1, this.yline1);
      }

      p5.pop();
    }

    p5.push();
    p5.stroke("white");
    p5.fill("white");
    p5.ellipse(this.xnumber, this.ynumber, 10);
    p5.fill(this.textColor);
    p5.textAlign(p5.CENTER, p5.CENTER);
    p5.textStyle(p5.BOLD);
    p5.text(i + 1, this.xnumber, this.ynumber);
    p5.stroke("black");
    p5.pop();
  };

  this.stackEditRender = (p5, i, wallTrait) => {
    let strokeColor = 180;
    let numberDepth = 3;

    // NUMBER

    this.xnumber =
      (size - depth * numberDepth) * p5.cos(a + 180 / trait.size) + xcenter;
    this.ynumber =
      (size - depth * numberDepth) * p5.sin(a + 180 / trait.size) + margin;

    if (wallTrait[i].doors) {
      p5.push();
      p5.stroke(strokeColor);
      p5.strokeWeight(1);
      p5.fill(this.color);
      p5.translate(this.x1, this.y1);
      p5.rotate(a - 30);
      p5.rect(0, 0, -depth / 2, this.d);
      p5.pop();
      p5.push();
      p5.strokeWeight(1);
      p5.line(this.x3, this.y3, this.x4, this.y4);
      p5.pop();
    } else {
      p5.push();
      p5.stroke(strokeColor);
      p5.strokeWeight(1);
      p5.fill(this.color);
      p5.beginShape();
      p5.vertex(this.x2, this.y2);
      p5.vertex(this.x1, this.y1);
      p5.vertex(this.x3, this.y3);
      p5.vertex(this.x4, this.y4);
      p5.vertex(this.x5, this.y5);
      p5.endShape();
      p5.pop();
    }

    if (wallTrait[i].windows) {
      p5.push();
      p5.stroke(strokeColor);
      p5.strokeWeight(1);
      p5.line(this.xwindow1, this.ywindow1, this.xwindow2, this.ywindow2);
      p5.pop();

      p5.push();
      p5.strokeWeight(0.5);
      // p5.line(this.xline1, this.yline1, this.xline2, this.yline2);
      p5.pop();

      const width1 = wallTrait[i].window1.windowW / wallTrait[i].pixels;
      const height1 = wallTrait[i].window1.windowH / wallTrait[i].pixels;
      const sill1 = wallTrait[i].window1.sill / wallTrait[i].pixels;
      let windowText1 = `${width1}x${height1}\n${wallTrait[i].window1.windowType}\n${sill1}" sill`;

      const width2 = wallTrait[i].window2.windowW / wallTrait[i].pixels;
      const height2 = wallTrait[i].window2.windowH / wallTrait[i].pixels;
      const sill2 = wallTrait[i].window2.sill / wallTrait[i].pixels;
      let windowText2 = `\n----\n${width2}x${height2}\n${wallTrait[i].window2.windowType}\n${sill2}" sill`;

      p5.push();

      p5.rectMode(p5.CENTER);
      p5.strokeWeight(0.1);
      p5.textAlign(p5.CENTER, p5.CENTER);
      p5.textSize(textSize);
      p5.fill(strokeColor);
      if (wallTrait[i].windows > 1) {
        if (wallTrait[i].window1.tempered === "TEMPERED") {
          windowText1 = windowText1 + `\nTEMPERED`;
        }
        if (wallTrait[i].window2.tempered === "TEMPERED") {
          windowText2 = windowText2 + `\nTEMPERED`;
        }

        windowText1 = windowText1 + windowText2;
        p5.noStroke();

        p5.text(windowText1, this.xline1, this.yline1);
      } else {
        if (wallTrait[i].window1.tempered === "TEMPERED") {
          windowText1 = windowText1 + `\nTEMPERED`;
        }
        p5.noStroke();
        p5.text("hello", this.xline1, this.yline1);
      }

      p5.pop();
    }

    p5.push();
    p5.stroke(this.textColor);
    p5.fill(this.color);
    p5.strokeWeight(0.1);
    p5.ellipse(this.xnumber, this.ynumber, 30);
    p5.fill(this.textColor);
    p5.textAlign(p5.CENTER, p5.CENTER);
    p5.text(i + 1, this.xnumber, this.ynumber);
    p5.pop();
  };
}
